export default __webpack_public_path__ + "6e977413a695e2a873e907dbdb09c4cc.svg";